import type { FloatingMenuItem, FloatingMenuProps } from './FloatingMenu'
import FloatingMenu from './FloatingMenu'

export type { FloatingMenuItem, FloatingMenuProps }
export default FloatingMenu
